"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSearchInput = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
// eslint-disable-next-line import/prefer-default-export
exports.StyledSearchInput = (0, styled_components_1.default)(ui_components_1.SearchInput) `
  &&&& {
    &.search-input-container {
      background-color: transparent;
      border: ${({ theme }) => theme.typography.pxToRem(1)} solid ${ui_components_1.baseColors.primaryBlueMed200};
      border-radius: ${({ theme }) => theme.spacing(0.5)};
    }

    .MuiInput-underline::before, .MuiInput-underline::after {
      border: 0;

      &.Mui-error::before, &.Mui-error::after {
        border: 0;
      }
    }

    .MuiInputBase-root {
      font-size: 0.875rem;
    }

    .search-icon {
      svg {
        width: ${({ theme }) => theme.spacing(1.75)};
        height: ${({ theme }) => theme.spacing(1.75)};
      }
    }
  }
`;
